
<script>

export default {

  name: 'location',
  props: ['locations', 'value', 'defaultLocations', 'defaultLocation'],  
  //template: '#location',
  data: function(){

      return {
          input_code:"",
          timer_send:0,
          params_location:"",
          input_location:"",
          select_location:"",
          get_locations:[],
          
      }
  },    
  methods: {

      changeLocation: function(location, item){

            item.lastValue = location.CODE;
            this.get_locations = [];

            if(location.DISPLAY)
            {
                this.input_location = location.DISPLAY;
            }
            else
            {
                this.input_location = location.NAME;
            }

            this.$emit('callparent', this.locations);
            


      },
        isMobile: function()
        {
       
             
                    return navigator.userAgent.match(/Android/i);
             
                
                    return navigator.userAgent.match(/BlackBerry/i);
              
               
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
               
                
                    return navigator.userAgent.match(/Opera Mini/i);
                
               
                    return navigator.userAgent.match(/IEMobile/i);
                
               
                 
                
           
        },
      focusInput: function()
      {

          if(this.isMobile())
          {
            let top = $(".bx-ui-sls-container").eq(0).offset().top;
		    $("html, body").animate({"scrollTop": top - 58 + "px"}, 500);
          }
         
      },

      focusInputOnce:function(){

        this.input_location = "";
      },

      clearField: function()
      {
          this.input_location = "";
      },
     getLocation: function(event){

            //console.log(this.params_location);
           this.input_location = event.target.value;

            var vue = this;

            clearTimeout(this.timer_send);

            this.timer_send = setTimeout(function(){

                let data = {
                    select:{
                        "1": "CODE",
                        "2": "TYPE_ID",
                        VALUE: "ID",
                        DISPLAY: "NAME.NAME"
                    },
                    additionals:{"1": "PATH"},
                    filter:{

                        "=PHRASE": vue.input_location,
                        //"=NAME.LANGUAGE_ID": vue.params_location.query.BEHAVIOUR.LANGUAGE_ID,
                        //"=SITE_ID": vue.params_location.query.FILTER.SITE_ID
                    },
                    version: 2,
                    PAGE_SIZE: 10,
                    PAGE: 0
                }

                BX.ajax({
					method: 'POST',
					dataType: 'json',
					url: "/bitrix/components/bitrix/sale.location.selector.search/get.php",
					data: data,
					onsuccess: BX.delegate(function(result) {

                        //console.log(result);
                        if(result.result)
                        {
                            // for(key in result.data.ITEMS)
                            // {
                                result.data.ITEMS.forEach(element => {
                                    
                                    //console.log(element);
                                    element["PATH_DISPLAY"] = [];

                                    element.PATH.forEach(path => {

                                        if(result.data.ETC.PATH_ITEMS[path].TYPE_ID > 2)
                                        {
                                            element["PATH_DISPLAY"].push(result.data.ETC.PATH_ITEMS[path].DISPLAY);
                                        }
                                        //console.log(result.data.ETC);
                                    });

                                    element["PATH_DISPLAY"] = element["PATH_DISPLAY"].join(", ");
                                });  
                              
                            //}
                            
                            vue.get_locations = result.data.ITEMS;
                            //vue.$set(vue, 'get_locations', result.data.ITEMS);
                                //console.log(result);
                        }
                        else
                        {
                             vue.get_locations = [];
                        }
                            
                
                        })
                }, this);

            }, 1000);
            


     }, 
            
  },

  created(){

    //   if(this.defaultLocationCode)
    //   {
    //       this.changeLocation({"CODE": this.defaultLocation.locationID, "NAME":this.defaultLocation.city}, {});
    //   }
    //   console.log(this.defaultLocationCode);
  },
  mounted() {

            
			
			
			var reg_location = /new BX\.Sale\.component\.location\.selector\.search\((.+)\)/mi;

            

			//console.log(this.data_js.locations);

            console.log(this.defaultLocation);
             if(this.defaultLocation)
             {
                    
            //     //console.log(this.defaultLocation);

                this.input_location = this.defaultLocation.NAME_RU;

                 for(key in this.locations){ 

                    this.locations[key].lastValue = this.defaultLocation.CODE;
                 }

                 this.$emit('callparent', this.locations);

            }
            // else
            // {
                //       for(key in this.locations){ 

                //         let init_code = this.locations[key].output[0];
                        
                //         let found = init_code.match(reg_location);
                        
                //         let config_loc = BX.parseJSON(found[1]);
                //         //console.log(found);
                //         this.params_location = config_loc;
                //         //this.data_js.locations[key].template = config_loc.scope;
                //         this.$set(this.locations[key], 'template', config_loc.scope);
                        
                //         let path_full = [];

                //         for(item_path in config_loc.knownItems)
                //         {
                //             if(config_loc.knownItems[item_path].TYPE_ID > 2)
                //             {
                //                 path_full.push(config_loc.knownItems[item_path].DISPLAY);
                //             }
                //         }
                //         this.input_location = path_full.join(", ");
                //         //var obj =  new BX.Sale.component.location.selector.search(config_loc);
                        
                // }
           //}
            

            
     }            
}

</script>



<template>

            <div class="bx_soa_location row">
							<div class="col-xs-12">
								<div v-for="(item, index) in locations" :data-property-id-row="index" :key="index" class="form-group bx-soa-location-input-container">
									<label class="bx-soa-custom-label" :for="'soa-property-'+index">
										<span class="bx-authform-starrequired">*</span> Город <br><small>(Выберите ваш город, чтобы мы могли рассчитать доставку)</small></label>

                                    <div class="default-loc" v-if="defaultLocations">
                                        <div class="one-def-loc" v-for="oneDef in defaultLocations" @click="changeLocation(oneDef, item)">
                                                {{oneDef.NAME}}
                                        </div>
                                    </div>
					
									<div :id="item.template" class="bx-sls ">

								
										<div class="dropdown-block bx-ui-sls-input-block form-control">

											<span class="dropdown-icon"></span>
											<input type="text" autocomplete="off" :name="'ORDER_PROP_'+index" :value="item.lastValue"  class="dropdown-field" placeholder="Введите название ..." style="display: none;">
											<div class="bx-ui-sls-container" style="margin: 0px; padding: 0px; border: none; position: relative;">
												<input type="text" disabled="disabled" autocomplete="off" class="bx-ui-sls-route" style="padding: 0px; margin: 0px;">
												<input type="text" autocomplete="off" value="" v-model="input_location" class="bx-ui-sls-fake" placeholder="Введите название ..." @keyup="getLocation($event)" @focus="focusInput" @focus.once="focusInputOnce">
                                                <div class="delete" @click="clearField"></div>
                                            </div>

                                        <div class="dropdown-fade2white"></div>
                                        <div class="bx-ui-sls-loader"></div>
                                        <div class="bx-ui-sls-clear" title="Отменить выбор" style="display: none;"></div>
                                        <div class="bx-ui-sls-pane" :class="{active:get_locations.length > 0}" >
                                            <div class="bx-ui-sls-variants">
                                                <div v-for="(item_loc, index) in get_locations" class="dropdown-item bx-ui-sls-variant" @click="changeLocation(item_loc, item)">
                                                    <span class="dropdown-item-text">
                                                        <span>{{item_loc.DISPLAY}}</span>, 
                                                    {{item_loc.PATH_DISPLAY}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

								    </div>

								

								

								<div class="bx-ui-sls-error-message">
											</div>

							</div>

							

						</div>
                        <input type="hidden" name="RECENT_DELIVERY_VALUE" value="">
							 
					</div>
		        </div>
</template>                        